import { SNACK_SHOW, SNACK_UNSET_MESSAGE } from '../constants/actionTypes';

export const snackShow = data => ({ type: SNACK_SHOW, payload: data });
export const snackUnsetMessage = () => ({
  type: SNACK_UNSET_MESSAGE,
  payload: null
});
